import { Directive, ElementRef, Input, OnInit } from '@angular/core';

import { Browser } from '../api/models/browser';

@Directive({
  selector: '[browserIcon]',
  standalone: true,
})
export class BrowserIconDirective implements OnInit {
  @Input('browserIcon') browser: Browser;

  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.element.nativeElement.className = this.getCssClassList();
  }

  getCssClassList(): string {
    let classList = 'mdi mdi-26px ';

    switch (this.browser) {
      case Browser.Chrome:
        classList += 'mdi-google-chrome tw-text-yellow-600';
        break;
      case Browser.Safari:
        classList += 'mdi-apple-safari tw-text-teal-500 dark:tw-text-teal-400';
        break;
      case Browser.Firefox:
        classList += 'mdi-firefox tw-text-orange-600 dark:tw-text-orange-500';
        break;
      case Browser.Edge:
        classList +=
          'mdi-microsoft-edge tw-text-indigo-600 dark:tw-text-indigo-500';
        break;
      case Browser.Opera:
        classList += 'mdi-opera tw-text-red-600 dark:tw-text-red-500';
        break;
      case Browser.GoogleSearchApp:
        classList += 'mdi-google tw-text-green-500 dark:tw-text-green-400'; // Google Search App
        break;
      case Browser.InternetExplorer:
        classList +=
          'mdi-microsoft-internet-explorer tw-text-blue-600 dark:tw-text-blue-400'; // Internet Explorer
        break;
      case Browser.Others:
        classList += 'mdi-web tw-text-gray-600 dark:tw-text-gray-500'; // Others
        break;
      case Browser.Unknown:
        classList +=
          'mdi-help-circle-outline tw-text-gray-400 tw-opacity-70 mdi-22px'; // Unknown
        break;
      default:
        classList += 'mdi-web tw-text-gray-500 dark:tw-text-gray-400';
        break;
    }

    return classList;
  }
}
